import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ['message']

    connect() {
        this.messageTargets.forEach(element => {
            this.toastr_notification(element.dataset)
        });
    }

    toastr_notification(dataset) {
        switch(dataset.type) {
            case 'danger':
            case 'alert':
            case 'error':
                toastr.error(dataset.msg)
                break
            case 'warning':
                toastr.warning(dataset.msg)
                break
            case 'notice':
            case 'success':
                toastr.success(dataset.msg)
                break
        }
    }
}
